import { time } from '@dr.pogodin/react-utils';

import { getBlogItem } from 'services/blog';

import { type BlogItemT, useAsyncCollection } from 'utils';

type UseBlogItemsResT = {
  items: Record<string, BlogItemT>;
  loading: boolean;
};

export default function useBlogItems(ids: string[]): UseBlogItemsResT {
  const e = useAsyncCollection(ids, 'blog.map', getBlogItem, {
    // NOTE: Carefull if we arrive to set a short `maxage` here - it will
    // reset ongoing edits in the blog post editor, the way it is currently
    // implemented, thus to have these reloaded frequently requires to also
    // update that editor.
    maxage: time.YEAR_MS,
  });

  // TODO: Cross update items in the blog list?

  const items: Record<string, BlogItemT> = {};
  for (const [id, item] of Object.entries(e.items)) {
    if (item.data) items[id] = item.data;
  }

  return { items, loading: e.loading };
}
